/**
 * 캐시 입출금 신청 내역 (/adm/account/list)
 * ($j.Pages.Admin.AccountList / body data-page-name="AccountList")
 *
 * 입금·출금은 컬럼 구성부터 다른 별개의 목록이라 탭을 바꾸면 표를 통째로 다시 만든다.
 * 출금 탭만 체크박스가 있고, 선택 행의 일괄 상태변경(대기·완료)·복사·엑셀을 한다.
 */
export default class AccountList {
    constructor() {
        this.$table = null;
        this.currentTab = 'exchange';
    }

    initialize() {
        this.loadTable();
        this.setActiveTabStyle();

        const today = dayjs();
        $('#start_date').val(today.subtract(1, 'week').format('YYYY-MM-DD'));
        $('#end_date').val(today.format('YYYY-MM-DD'));

        this.initHandler();
    }

    initHandler() {
        $('#start_date, #end_date').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [], // 설정 버튼 제거
        });

        // 회원 검색칸 자동완성 — 고르면 '이름#번호' 가 들어가고 그 텍스트가 곧 검색기준이다
        $j.F.Admin.Util.memberSearch('find-user-kwd');

        $('#find-user-search-btn').on('click', () => this.$table.ajax.reload());

        // 선택 액션 버튼
        const actions = {
            wait:     () => this.bulkChangeStatus('wait'),      // 미출금(20) → 출금대기(21)
            complete: () => this.bulkChangeStatus('complete'),  // 출금대기(21) → 출금완료(22)
            copy:     () => this.selectCopy(),
            excel:    () => this.selectExcel(),
        };
        $('#selectBtn').on('click', '[data-act]', (e) => actions[$(e.currentTarget).data('act')]());

        const $tbl = $('#table');

        // 계좌번호 복사 — 대시·공백 없이 숫자만. #table 은 탭을 바꿔도 남으므로 여기서 한 번만 건다
        $tbl.on('click', '.ac-acc-copy', (e) => {
            e.stopPropagation();
            const data = this.$table.row($(e.currentTarget).closest('tr')).data();
            this.copyToClipboard(String(data.account || '').replace(/\D/g, ''));
        });

        // 선택칸 — 상자 밖 여백을 눌러도 체크를 뒤집는다 (상자 자체 클릭은 브라우저가 처리)
        $tbl.on('click', 'td.ac-check', (e) => {
            if ($(e.target).is('.row-checkbox')) return;
            const $cb = $(e.currentTarget).find('.row-checkbox');
            $cb.prop('checked', !$cb.prop('checked')).trigger('change');
        });

        // 체크박스 클릭 시 배경색 변경 + 선택된 요청포인트 합계 갱신
        $tbl.on('change', '.row-checkbox', (e) => {
            const $row = $(e.currentTarget).closest('tr');
            $row.find('td').toggleClass('cr-background-selected', $(e.currentTarget).prop('checked'));
            this.updateSelectedSum();
        });

        // 페이지 전환 / 탭 전환 / 재조회 시 합계 리셋 (체크 상태가 사라지므로 0 으로 자연스럽게 돌아감)
        $tbl.on('draw.dt', () => this.updateSelectedSum());

        $('#acTabs a').on('click', (e) => {
            e.preventDefault();
            this.switchTab($(e.currentTarget).data('tab'));
        });
    }

    /** 테이블 — 탭마다 컬럼이 달라 새로 만든다 */
    loadTable() {
        const shortDate = (v) => this.shortDate(v);
        const korAmount = (v) => { const k = this.korAmount(v); return k ? k + '원' : ''; };
        const memberNo  = (v, t, row) => $j.F.Admin.Member.Pop.cellNo(row.mb_no);   // 번호를 누르면 회원 팝오버 — 이름 칸이 따로 있어 번호만 적는다
        // 제재 딱지 — g5_member_owners.penalty (0정상/1경고/2차단/3환원)
        const memberName = (data, type, row) => $j.F.Admin.Util.penaltyCard(row.penalty) + data;
        const status = (v) => this.formatStatus(v);

        const columns = this.currentTab === 'deposit' ? [
            {data: 'request_date', title: '요청일', render: shortDate},
            {data: 'type', title: '입금 유형'},
            {data: 'mb_no', title: '회원 번호', render: memberNo},
            {data: 'mem_name', title: '회원 이름', render: memberName},
            {data: 'amount', title: '요청 포인트'},
            {data: 'amount', title: '한글', className: 'ac-amt-kor', render: korAmount},
            {data: 'mem_phone', title: '연락처'},
            {data: null, title: '불러!톡', render: () => '<i class="fas fa-comment-dots"></i> 채팅'},
            {data: 'request_username', title: '예금주명'},
            {data: 'process_date', title: '처리시간', render: shortDate},
            {data: 'status', title: '상태', render: status}
        ] : [
            {data: null, className: 'ac-check', render: () => '<input type="checkbox" class="row-checkbox">', orderable: false},
            {data: 'num', title: 'No.'},
            {data: 'request_date', title: '요청일', render: shortDate},
            {data: 'mb_no', title: '회원 번호', render: memberNo},
            {data: 'mem_name', title: '회원 이름', render: memberName},
            {data: 'amount', title: '요청 포인트'},
            {data: 'amount', title: '한글', className: 'ac-amt-kor', render: korAmount},
            {data: 'mem_phone', title: '연락처'},
            {data: null, title: '불러!톡', render: () => '<i class="fas fa-comment-dots"></i> 채팅'},
            {data: 'bank', title: '은행명'},
            {
                data: 'account',
                title: '계좌번호',
                render: v => v
                    ? '<span class="ac-acc">' + $j.Common.Util.escapeHtml(v)
                        + '<button type="button" class="ac-acc-copy" title="숫자만 복사"><i class="fas fa-copy"></i></button></span>'
                    : ''
            },
            {data: 'actholder', title: '예금주명'},
            {data: 'process_date', title: '처리시간', render: shortDate},
            {data: 'status', title: '상태', render: status},
            {data: 'manage_name', title: '처리자'},
            {data: null, title: '결과공유', render: () => '<i class="fas fa-copy"></i> 복사'}
        ];

        if (this.$table) {
            this.$table.destroy();
            $('#table').empty();  // 테이블 내용을 비워서 초기화
        }

        this.$table = new DataTable('#table', {
            autoWidth: false,
            columns: columns,
            rowCallback: (row, data) => this.formatRow(row, data),
            ajax: {
                url: '/adm/ajax/account/list',
                type: 'post',
                data: (d) => {
                    d.findUserKwd = $('#find-user-kwd').val();
                    d.statusFilter = this.currentTab;
                    d.start_date = $('#start_date').val();
                    d.end_date = $('#end_date').val();
                },
            },
            processing: true,
            serverSide: true,
            ordering: false,
            displayLength: 20,
            lengthChange: false,
            searching: false
        });

        // 칸 클릭 — 탭마다 칸 순서가 다르다. tbody 는 표를 새로 만들 때 같이 새로 생기므로 여기서 건다
        const $tbody = $('#table tbody');
        const onCell = (n, fn, byTr = false) => $tbody.on('click', `td:nth-child(${n})`, (e) => {
            const data = this.$table.row(byTr ? $(e.currentTarget).closest('tr') : e.currentTarget).data();
            fn(data);
            e.stopPropagation();
        });

        if (this.currentTab === 'exchange') {
            // 요청 포인트 — 캐시내역. 회원번호(4)는 팝오버가 맡는다(그 안의 '모바일 캐시내역' 이 같은 창을 연다)
            onCell(6, (d) => $j.F.Admin.Util.userCash(d.mb_no));
            onCell(5, (d) => $j.F.Admin.Util.memberPortal(d.mb_no));                // 회원이름
            onCell(9, (d) => $j.F.Admin.Util.chat(d.mb_no, d.mem_name));            // 불러톡
            onCell(14, (d) => this.statusPopup(d), true);                           // 상태
            onCell(16, (d) => this.copyResult(d), true);                            // 결과공유
        } else {
            onCell(2, (d) => $j.F.Admin.Util.userCash(d.mb_no));                    // 입금 유형 칸 — 캐시내역
            onCell(4, (d) => $j.F.Admin.Util.memberPortal(d.mb_no, '/m/account/deposit')); // 회원이름 — 기사관리 + 우측 충전화면
            onCell(8, (d) => $j.F.Admin.Util.chat(d.mb_no, d.mem_name));            // 불러톡
        }
    }

    /**
     * 상태 뱃지. tone 은 뱃지 색 — 행 배경색(cr-background-*)과 **같은 뜻**을 반복해 준다.
     * 색맹·흑백 출력에서도 상태가 읽히도록 글자를 함께 둔다.
     */
    formatStatus(data) {
        const statusArray = {
            deposit: [
                { status: '10', text: '미입금',   tone: 'danger'    },
                { status: '11', text: '입금완료', tone: 'success'   },
                { status: '12', text: '입금취소', tone: 'secondary' },
            ],
            exchange: [
                { status: '20', text: '미출금',   tone: 'danger'    },
                { status: '21', text: '대기',     tone: 'warning'   },
                { status: '22', text: '출금',     tone: 'success'   },
                { status: '23', text: '출금취소', tone: 'secondary' },
            ],
        };
        const status = statusArray[this.currentTab].find((item) => item.status == data);
        if (!status) return '<span class="badge badge-light">알 수 없음</span>';
        return `<span class="badge badge-${status.tone} ac-status">${status.text}</span>`;
    }

    /**
     * 금액 한글 읽기 — 만 단위 안쪽도 천·백으로 끊는다 (1000000 → '1백만', 12500000 → '1천 2백 50만', 158000 → '15만 8천').
     * 공용 Util.toKoreanAmount 는 만 단위를 숫자로 둬서 '100만' 이 되는데, 출금 확인에선 자릿수가 바로 읽히는 쪽이 낫다.
     */
    korAmount(n) {
        const num = Math.trunc(Number(n));
        if (!Number.isFinite(num) || num <= 0) return '';
        // 0~9999 를 천·백으로 끊고 백 미만은 숫자로 — 마지막 조각 뒤에 단위를 붙인다
        const split = (v, unit) => {
            const p = [];
            if (Math.floor(v / 1000)) p.push(Math.floor(v / 1000) + '천');
            if (Math.floor(v % 1000 / 100)) p.push(Math.floor(v % 1000 / 100) + '백');
            if (v % 100) p.push(String(v % 100));
            if (p.length) p[p.length - 1] += unit;
            return p;
        };
        const eok = Math.floor(num / 1e8);
        return [
            ...(eok ? [eok.toLocaleString() + '억'] : []),
            ...split(Math.floor(num % 1e8 / 1e4), '만'),
            ...split(num % 1e4, ''),
        ].join(' ');
    }

    /** 요청일·처리시간 — 칸을 좁히려 YY-MM-DD HH:mm (연도 두 자리·초 생략) */
    shortDate(v) {
        const d = v ? dayjs(String(v).replace('T', ' ')) : null;
        if (!d || !d.isValid() || d.year() < 2000) return '';
        return `<span class="ac-date">${d.format('YY-MM-DD')} <span class="ac-time">${d.format('HH:mm')}</span></span>`;
    }

    switchTab(tab) {
        this.currentTab = tab;
        this.setActiveTabStyle();
        this.loadTable();
    }

    /** 현재 탭 표시 + 선택 액션(출금대기/완료/복사/엑셀)은 체크박스가 있는 출금 탭 전용 */
    setActiveTabStyle() {
        $('#acTabs a').removeClass('active').filter('[data-tab="' + this.currentTab + '"]').addClass('active');
        $('#selectBtn').toggle(this.currentTab === 'exchange');
    }

    /**
     * 행 꾸미기 — 회원이름·채팅·복사는 관리자 화면 관례대로 파란 글씨(cr-bold-blue)로 클릭 가능함을 알리고,
     * 돈(요청 포인트)만 오른쪽 정렬(cr-right-align), 나머지는 가운데 정렬.
     */
    formatRow(row, data) {
        const pointHtml = `<span class="ac-amt">${Number(data.amount).toLocaleString()}</span>`;
        const $r = $(row);

        if (this.currentTab === 'exchange') {
            $r.find('td:nth-child(14)').addClass('ac-click'); // 상태 — 누르면 상태변경
            $r.find('td:nth-child(16)').addClass('cr-bold-blue ac-click'); // 결과공유(복사)
            $r.find('td:nth-child(5)').addClass('cr-bold-blue ac-click'); // 회원이름
            $r.find('td:nth-child(6)').addClass('cr-right-align request-points').html(pointHtml); // 요청 포인트
            $r.find('td:nth-child(9)').addClass('cr-bold-blue ac-click'); // 불러톡(채팅)
            $r.find('td:nth-child(4)').addClass('ac-click'); // 회원번호 → 캐시내역
        } else {
            $r.find('td:nth-child(4)').addClass('cr-bold-blue ac-click'); // 회원이름
            $r.find('td:nth-child(5)').addClass('cr-right-align request-points').html(pointHtml); // 요청 포인트
            $r.find('td:nth-child(8)').addClass('cr-bold-blue ac-click'); // 불러톡(채팅)
            $r.find('td:nth-child(2)').addClass('ac-click'); // 회원번호 → 캐시내역
        }

        // 상태에 따라 배경색 — 미입금·미출금 빨강 / 출금대기 노랑 / 취소 회색 / 그 외 흰색
        const s = String(data.status);
        const bg = (s === '10' || s === '20') ? 'cr-background-red'
            : s === '21' ? 'cr-background-yellow'
            : (s === '23' || s === '12') ? 'cr-background-gray'
            : 'cr-background-white';
        $r.find('td').addClass(bg);
    }

    copyToClipboard(text) {
        const $textarea = $('<textarea>').val(text).appendTo('body');
        $textarea.get(0).select();
        $textarea.get(0).setSelectionRange(0, 99999); // 모바일 지원
        document.execCommand('copy');
        $textarea.remove();
        $j.F.Admin.Util.tsalert('success', '클립보드에 복사되었습니다');
    }

    formatText(data) {
        return `${data.mem_name} - ${data.bank} ${Number(data.amount).toLocaleString()} 환불완료`;
    }

    /** 결과공유 — 출금완료 건만 */
    copyResult(data) {
        if (data.status != '22') {
            $j.Common.Util.swalert('출금이 완료되지 않았습니다.');
            return;
        }
        this.copyToClipboard(this.formatText(data));
    }

    /** 체크된 행 데이터 */
    checkedRows() {
        const rows = [];
        $('#table tbody input.row-checkbox:checked').each((i, el) => {
            const data = this.$table.row($(el).closest('tr')).data();
            if (data) rows.push(data);
        });
        return rows;
    }

    /** 다중 선택 복사 — 출금완료 건만 */
    selectCopy() {
        const lines = this.checkedRows().filter(d => d.status == '22').map(d => this.formatText(d));
        if (lines.length == 0) {
            $j.Common.Util.swalert('선택된 행이 없거나,\n출금이 완료되지 않은 데이터가 포함되어 있습니다.');
            return;
        }
        this.copyToClipboard(lines.join('\n'));
    }

    /**
     * 선택(체크) 행을 엑셀로 저장. 체크된 항목이 없으면 현재 필터 전체를 내보낸다.
     * 필터(WHERE)는 목록 ajax(getCashRequest)가 세션에 저장한 것을 서버에서 재사용한다.
     */
    selectExcel() {
        const nums = this.checkedRows().map(d => d.num);
        location.href = '/excel/account/cash?nums=' + encodeURIComponent(nums.join(','));
    }

    /**
     * 체크된 행을 일괄 상태변경. cfg.from 상태만 허용, 그 외 섞이면 중단.
     * @param key BULK_STATUS_ACTIONS 의 키 (wait / complete)
     */
    bulkChangeStatus(key) {
        const cfg = BULK_STATUS_ACTIONS[key];
        const checked = this.checkedRows();
        const selectedRows = checked.filter(d => d.status == cfg.from);

        // 대상 상태 아닌 항목이 섞이면 중단
        if (selectedRows.length !== checked.length) {
            $j.Common.Util.swalert(cfg.fromLabel + '만 \n 일괄 처리할 수 있습니다.');
            return;
        }
        if (selectedRows.length == 0) {
            $j.Common.Util.swalert('선택된 ' + cfg.fromLabel + ' 항목이 없습니다.');
            return;
        }

        $j.Common.Util.swalert([selectedRows.length + '건을 ' + cfg.toLabel + '로 \n 변경하시겠습니까?', 'question'], () => {
            let successCount = 0;
            let processedCount = 0;
            const okRows = [];    // 성공한 행만 클립보드 복사 (실패건 계좌가 섞이면 송금사고)
            const failMsgs = [];  // 출금금지 회원 등 서버가 거부한 사유
            selectedRows.forEach((data) => {
                const payload = {
                    action: cfg.action,
                    num: data.num,
                    mb_no: data.mb_no,
                    amount: data.amount,
                };
                if (cfg.memo) {
                    payload.memo = `${dayjs().format('MM-DD')} ${data.mem_name} 포인트환불 (${data.bank})`;
                }
                $.ajax({
                    url: '/adm/ajax/account/update',
                    type: 'POST',
                    data: payload,
                    success: (response) => {
                        if (response.success) {
                            successCount++;
                            okRows.push(data);
                        } else {
                            failMsgs.push(`${data.mem_name || data.num} : ${response.message || '알 수 없음'}`);
                            console.warn(`${data.num} 실패: ${response.message || '알 수 없음'}`);
                        }
                    },
                    error: () => {
                        failMsgs.push(`${data.mem_name || data.num} : 처리 중 오류`);
                        console.error(`${data.num} 처리 중 오류 발생`);
                    },
                    complete: () => {
                        // 모든 항목 처리 후 안내 + (출금완료면 복사) + 테이블 새로고침
                        if (++processedCount >= selectedRows.length) {
                            let msg = successCount + '건의 ' + cfg.toLabel + ' 처리가 \n 완료되었습니다.';
                            if (failMsgs.length) msg += `\n\n실패 ${failMsgs.length}건\n` + failMsgs.join('\n');
                            $j.F.Admin.Util.tsalert('info', msg);
                            setTimeout(() => {
                                if (cfg.copy && okRows.length) this.copyToClipboard(okRows.map(d => this.formatText(d)).join('\n'));
                                this.$table.ajax.reload(null, false);
                            }, 100);
                        }
                    }
                });
            });
        }, ['네', '아니오']);
    }

    /** 상태 칸 클릭 — 미출금은 여기서 바꾸고, 출금대기는 확인 창에서 완료/취소한다 */
    statusPopup(data) {
        switch (String(data.status)) {
            case '20': // 미출금
                $j.Common.Util.swalert(['캐시 출금 상태 변경', 'warning'], () => {
                    this.changeStatus('wait', data); // 출금대기
                }, ['출금대기', '출금취소'], () => {
                    this.changeStatus('cancel', data); // 출금취소
                });
                break;
            case '21': // 출금 대기
                this.openReview(data.num);
                break;
            case '23':
                $j.Common.Util.swalert('이미 취소된 건입니다.');
                break;
            default:
                $j.Common.Util.swalert('이미 출금된 건입니다.');
                break;
        }
    }

    openReview(num) {
        // 이 창은 기사관리 iframe 을 품는다. edit-v2 는 4열이 1240px 부터 유지되므로
        // 우측 앱화면(400px)·여백까지 하면 1700 은 돼야 상담열이 안 접힌다.
        const w = Math.min(1700, screen.availWidth  || 1700);
        const h = Math.min(900,  screen.availHeight || 900);
        const win = window.open(`/adm/account/review?num=${num}`, '_blank', `width=${w},height=${h}`);
        win.focus();
    }

    changeStatus(action, data) {
        $.ajax({
            url: '/adm/ajax/account/update',
            type: 'POST',
            data: { action: action, num: data.num, mb_no: data.mb_no, amount: data.amount },
            success: (response) => {
                if (response.success) {
                    $j.F.Admin.Util.tsalert('info', '상태가 성공적으로 변경되었습니다.');
                    this.$table.ajax.reload();
                } else {
                    $j.F.Admin.Util.tsalert('info', response.message || '처리에 실패하였습니다. 페이지를 새로고침하세요');
                }
            }
        });
    }

    /**
     * 현재 페이지에서 체크된 행들의 요청포인트(amount)를 합산해 상단에 표시한다.
     * - 출금 탭 전용. 입금 탭에는 체크박스가 없으므로 숨김.
     * - serverSide 모드라 선택은 현재 페이지에 한정되며, 페이지 전환 시 자동 리셋(draw.dt 이벤트).
     */
    updateSelectedSum() {
        const $info = $('#selected-sum-info');
        if (this.currentTab !== 'exchange' || !this.$table) {
            $info.text('');
            return;
        }
        const rows = this.checkedRows();
        const sum = rows.reduce((s, d) => s + (Number(d.amount) || 0), 0);
        $info.html(rows.length ? `선택 ${rows.length}건 합계 <b>${sum.toLocaleString()}</b> 원` : '');
    }
}

/** 일괄 상태변경 설정 — from(대상 status) → action(서버 처리) */
const BULK_STATUS_ACTIONS = {
    wait:     { from: '20', action: 'wait',     fromLabel: '미출금',   toLabel: '출금 대기', copy: false, memo: false },
    complete: { from: '21', action: 'complete', fromLabel: '출금 대기', toLabel: '출금 완료', copy: true,  memo: true },
};
